module.exports = __webpack_public_path__ + "img/pagerBank.e5b14ec6.png";